import settings from '@/libs/constant/settings'
import {verifyPocketCode, verifyTwitterAuth, verifyFacebookAuth, emailVerifyPeople, emailVerifyTeam, emailVerifyBillingManager, emailVerifyCollaborator, accountDeletePermanently} from '@/libs/api/api'
import pageRoute from '@/libs/constant/pageRoutes'
import {openInNewTab, logout} from '@/libs/helper'

export default {
    name: 'AccountConfirmation',
    beforeMount () {
        let language = localStorage.getItem('lang')
        this.$i18n.locale = language || settings.LOCIZE.LANGUAGE.ENGLISH_GB
        if (this.$route.name === pageRoute.pocketConfirmation) {
            this.getPocketVerified()
        } else if (this.$route.name === pageRoute.twitterConfirmation) {
            this.getTwitterVerified()
        } else if (this.$route.name === pageRoute.facebookConfirmation) {
            this.getFacebookVerified()
        } else if (this.$route.name === pageRoute.organisationInvite) {
            this.getOrganisationVerified()
        } else if (this.$route.name === pageRoute.teamInvite) {
            this.getTeamVerified()
        } else if (this.$route.name === pageRoute.billingManagerInvite) {
            this.getBillingManagerVerified()
        } else if (this.$route.name === pageRoute.collaboratorInvite) {
            this.getCollaboratorVerified()
        } else if (this.$route.name === pageRoute.deleteUserAccount) {
            this.deleteUserPermanently()
        }
    },
    data() {
        return {
            message: ''
        }
    },
    methods: {
        getIcon () {
            return require('@/assets/images/Accura logo design_Web_blue.svg')
        },
        getPocketVerified () {
            this.message = 'Please wait, connecting with pocket ...'
            let code = this.$route.query.code || ''
            let token = this.$route.query.token || ''
            let body = {
                code
            }
            verifyPocketCode(body, token).then(() => {
                this.message = 'Account added successfully. Close this window, go to the Accura Documents App and click Refresh to sync the pocket account.'
            }).catch(error => {
                this.message = error.message
            })
        },
        getTwitterVerified () {
            this.message = 'Please wait, connecting with twitter ...'
            let oauth_token = this.$route.query.oauth_token || ''
            let verifier = this.$route.query.oauth_verifier || ''
            let body = {
                oauth_token,
                verifier
            }
            verifyTwitterAuth(body).then(() => {
                this.message = 'Account added successfully. Close this window, go to the Accura Documents App and click Refresh to sync the twitter account.'
                this.$store.dispatch('setRefreshAccounts', true)
            }).catch(error => {
                this.message = error.message
            })
        },
        getFacebookVerified () {
            this.$store.dispatch('setAccountRefreshed', true)
            this.message = 'Please wait, connecting with facebook ...'
            let code = this.$route.query.code || ''
            let state = this.$route.query.state || ''
            // api call
            let body = {
                code, state
            }
            verifyFacebookAuth(body).then(() => {
                this.message = 'Account added successfully.'
                this.$store.dispatch('setRefreshAccounts', true)
            }).catch(error => {
                this.message = error.message
            })
        },

        /**
         * get Organisation verified
         */
        getOrganisationVerified () {
            this.message = 'Please wait, verifying...'
            let body = {
                action: this.$route.query.action || '',
                unique_id: this.$route.query.uniqueId || '',
                organisation: this.$route.query.entityId || ''
            }
            emailVerifyPeople(body).then((response) => {
                this.message = 'Organisation member verified successfully'
                // to route to the user to organisation overview page
                setTimeout(() => {
                    openInNewTab(response.redirect_url, true)
                }, 3000)
            }).catch(error => {
                this.message = error.message
            })
        },

        /**
         * get team verified
         */
        getTeamVerified () {
            this.message = 'Please wait, verifying...'
            let body = {
                action: this.$route.query.action || '',
                unique_id: this.$route.query.uniqueId || '',
                team: this.$route.query.entityId || ''
            }
            emailVerifyTeam(body).then((response) => {
                this.message = 'Member verified successfully'
                // to route to the user to team overview page
                setTimeout(() => {
                    openInNewTab(response.redirect_url, true)
                }, 3000)
            }).catch(error => {
                this.message = error.message
            })
        },
        /**
         * to verify the billing manager added to organisation
         */
        getBillingManagerVerified () {
            this.message = 'Please wait, verifying...'
            // body for api call
            let body = {
                action: this.$route.query.action || '',
                unique_id: this.$route.query.uniqueId || '',
                organisation: this.$route.query.entityId || ''
            }
            // api call
            emailVerifyBillingManager(body).then((response) => {
                // show success message
                this.message = 'Biiling Manager verified successfully'
                // to route to the user to billing manager page
                setTimeout(() => {
                    openInNewTab(response.redirect_url, true)
                }, 3000)
            }).catch(error => {
                this.message = error.message
            })
        },
        getCollaboratorVerified () {
            this.message = 'Please wait, verifying...'
            let body = {
                action: this.$route.query.action || '',
                unique_id: this.$route.query.uniqueId || '',
                invite_id: this.$route.query.entityId || ''
            }
            // api call
            emailVerifyCollaborator(body).then((response) => {
                this.message = 'Collaborator verified successfully'
                // to route to the user to team overview page
                setTimeout(() => {
                    openInNewTab(response.redirect_url, true)
                }, 3000)
            }).catch(error => {
                this.message = error.message
            })
        },

        /**
         * delete user permanently
         */
        async deleteUserPermanently () {
            // if approve
            if (this.$route.query.action === 'approve') {
                // message
                this.message = 'Please wait..'
                // api call to delete user
                await accountDeletePermanently(this.$route.query.entityId)
                // logout
                logout(this)
            } else {
                // if denied push it to sign-in page
                this.$router.push('/sign-in')
            }
            
        }
    }
}